import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";

export default () => {
  const [isFloat, setIsFloat] = useState(false);
  useEffect(() => {
    window.addEventListener("scroll", isSticky);
    return () => {
      window.removeEventListener("scroll", isSticky);
    };
  });
  const isSticky = () => {
    const scrollTop = window.scrollY;
    if (scrollTop >= 250) {
      setIsFloat(true);
    } else {
      setIsFloat(false);
    }
  };
  return (
    <div>
      {isFloat && (
        <Button
          className="btn-back-top text-white sb-ga-click sb-ga-scroll sb-ga-scroll-tracked d-flex"
          onClick={() => {
            window.scrollTo({ top: 0, behavior: "smooth" });
          }}
        >
          <i className="las la-arrow-up" />
        </Button>
      )}
    </div>
  );
};
